import { getCurrentDateInSeconds } from '@/utilities/timeDifference';

export default {
  data() {
    return {
      currentDate: getCurrentDateInSeconds(),
      dueDateInterval: null,
      overdueDateInterval: null,
    };
  },
  computed: {
    currentUserId() {
      return this.$store.getters.getUser.id;
    },

    cards() {
      return this.$store.getters.getCards || {};
    },
  },
  methods: {
    setDateReminder(reminder, cardId = this.currentCardId) {
      const reminderValue = !Number.isNaN(reminder) ? reminder : '';
      this.$store.dispatch('localUpdateCardField', {
        cardId,
        fieldName: 'dueDateReminder',
        fieldValue: reminderValue,
      });
    },

    clearDateInterval(key) {
      clearInterval(this[key]);
      this[key] = null;
    },

    initializeDueDateInterval(cardDueDate) {
      if (cardDueDate > this.currentDate) {
        const timeInterval = cardDueDate * 1000 - this.currentDate * 1000;
        this.dueDateInterval = setInterval(() => {
          this.clearDateInterval('overdueDateInterval');
          this.currentDate = getCurrentDateInSeconds();
          this.clearDateInterval('dueDateInterval');
          this.setOverdueInterval(cardDueDate);
        }, timeInterval);
      } else {
        this.setOverdueInterval(cardDueDate);
      }
    },

    setOverdueInterval(cardDueDate, timeInterval = 1000) {
      this.clearDateInterval('overdueDateInterval');
      this.overdueDateInterval = setInterval(() => {
        this.currentDate = getCurrentDateInSeconds();
        const dateDifference = this.currentDate * 1000 - cardDueDate * 1000;
        if (dateDifference >= 60000) {
          return this.setOverdueInterval(cardDueDate, 60000);
        }
        if (dateDifference >= 10000 && dateDifference < 60000) {
          return this.setOverdueInterval(cardDueDate, 10000);
        }
        return this.setOverdueInterval(cardDueDate);
      }, timeInterval);
    },

    removeDate(property = 'due_date') {
      this.setCardDate(0, '', property);
    },

    setCardDate(date, reminder, property = 'due_date', cardId = this.currentCardId) {
      const card = this.cards[cardId];
      if (!card || !card.id) return;
      const isDueDate = property === 'due_date';
      const oldDate = card[property];
      const oldReminder = card.dueDateReminder;

      // prevent seting the same values
      if (oldDate === date && oldReminder === reminder) {
        return;
      }
      this.currentDate = getCurrentDateInSeconds();
      if (isDueDate) {
        this.setDateReminder(reminder, cardId);
        this.clearDateInterval('dueDateInterval');
        this.clearDateInterval('overdueDateInterval');
        if (card[property] > this.currentDate) {
          this.initializeDueDateInterval(date);
        } else {
          this.setOverdueInterval(date);
        }
      }
      this.$store
        .dispatch('updateCardWithPatchRequest', {
          cardId,
          card: {
            [property]: date,
          },
        })
        .catch(() => {
          this.currentDate = getCurrentDateInSeconds();
          if (isDueDate) {
            this.setDateReminder(oldReminder, cardId);
            this.clearDateInterval('dueDateInterval');
            this.clearDateInterval('overdueDateInterval');
            if (card[property] > this.currentDate) {
              this.initializeDueDateInterval(oldDate);
            } else {
              this.setOverdueInterval(oldDate);
            }
          }
        });
    },
  },
};
